module.exports = __webpack_public_path__ + "static/media/投诉请求.af02a4c1.png";